import CrossIcon from "@components/icons/cross-icon";
import TickIcon from "@components/icons/tick-icon";
import { roundness } from "@provider/dripsy";
import { Text, View } from "dripsy";
import * as React from "react";

interface AlertMessageTypes {
  isSuccess: boolean;
  children: string;
  testID?: string;
}

function AlertMessage({ isSuccess, children, testID }: AlertMessageTypes) {
  return (
    <View
      testID={testID}
      sx={{
        backgroundColor: isSuccess ? "$lightGreenOpacity12" : "$errorOpacity12",
        borderRadius: roundness,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        padding: 12,
      }}
    >
      <View>{isSuccess ? <TickIcon size={18} color="$lightGreen" /> : <CrossIcon size={18} color="$error" />}</View>
      <View sx={{ flex: 1 }}>
        <Text
          sx={{
            color: isSuccess ? "$lightGreen" : "$error",
            marginLeft: 12,
          }}
        >
          {children}
        </Text>
      </View>
    </View>
  );
}

export default AlertMessage;
